import React, { useEffect, useState } from 'react';
import BoxPayGrid from '../BoxPayGrid';
import { useAuth } from '../../context/API_Client';
import { customToast } from '../../reusableComponents/customToaster/customToast';
import FileSaver from "file-saver";
import { GenerateReportSchema } from './GenerateReportSchema';
import LoadingLogoPage from '../loadingPage/loadingPage';
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import { colorBrandObject } from '../../../constants/brandings';
import ContentHeader from '../../reusableComponents/contentHeader/ContentHeader';

export const GeneratedReportTable = (props) => {
    const {
        reportData,
        handleGenerateReport,
        operationPermissions,
        fileSetConfig,
        customPagination,
        pageNo,
        setPageNo,
        pageLimit,
        setPageLimit,
        totalDataCount,
        loader
    } = props
    const { downloadFileUrlOpen, merchantSettings } = useAuth();
    const [timezone, setTimezone] = useState("");

    const handleDownload = (url) => {
        downloadFileUrlOpen(url)
    };

    useEffect(() => {
        merchantSettings(
            function (data) {
                setTimezone(data?.timeZone);
            },
            function (errorMsg) {
                customToast("error", "high", errorMsg);
            }
        );
    }, [])
    return (
        <>
            <div style={{ backgroundColor: "white" }}>
                <section>
                    <div className="reportMainDiv">
                        <ContentHeader
                            firstHeading="Reports"
                            secondHeading="Get a handle of all files in a batch view"
                            buttonPermissions={[operationPermissions.createGenReconReport]}
                            icon={<SummarizeOutlinedIcon sx={{ color: colorBrandObject.sideBarSelectedOptionBackground }} />}
                            buttonText="Generate Report"
                            buttonType="primary"
                            buttonSize="md"
                            buttonVariant="contained"
                            buttonOnclick={handleGenerateReport}
                        />
                        <div style={{ marginTop: "32px", width: "100%", display: "flex" }}>
                            <BoxPayGrid
                                schema={GenerateReportSchema(handleDownload, operationPermissions, fileSetConfig, timezone)}
                                data={reportData}
                                loader={loader}
                                showCustomizeButton={false}
                                customPagination={customPagination}
                                pageNo={pageNo}
                                setPageNo={setPageNo}
                                pageLimit={pageLimit}
                                setPageLimit={setPageLimit}
                                totalDataCount={totalDataCount}
                            />
                            {/* {loader || true ? (
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        marginTop: "24px",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: loader ? "50vh" : "auto",
                                    }}
                                >
                                    <LoadingLogoPage />
                                </div>
                            ) : (
                                <BoxPayGrid
                                    schema={GenerateReportSchema(handleDownload, operationPermissions, fileSetConfig)}
                                    data={reportData}
                                    loader={loader}
                                    showCustomizeButton={false}
                                    customPagination={customPagination}
                                    pageNo={pageNo}
                                    setPageNo={setPageNo}
                                    pageLimit={pageLimit}
                                    setPageLimit={setPageLimit}
                                    totalDataCount={totalDataCount}
                                />
                            )} */}
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
